const schema = [
        ['name'],
        ['timeZone'],
        ['description'],
];

export default schema;
